/* Event Masonry */
(function ($) {
  Drupal.behaviors.masonryview = {
    attach: function (context, settings) {
      var $grid = $(
        ".grid-masonry .views-infinite-scroll-content-wrapper"
      ).imagesLoaded(function () {
        $grid.masonry({
          itemSelector: ".grid-masonry-item",
        });
      });
      $(document).ajaxComplete(function () {
        $grid.masonry("reloadItems");
      });
    },
  };
})(jQuery);

/* Headroom - Auto hide Header when scrolling */
(function ($) {
  Drupal.behaviors.headroomheader = {
    attach: function (context, settings) {
      /* Fixed menu only for log out users, since don't have the administration toolbar. */
      if (!$(".toolbar-lining")[0] || !$("#toolbar-bar")[0]) {
        var elem = document.querySelector(".header-wrapper");
        var headroom = new Headroom(elem, {
          offset: 205,
          tolerance: 5,
          classes: {
            initial: "animated",
            pinned: "slideUp",
            unpinned: "slideDown",
          },
        });
        headroom.init();

        // to destroy
        headroom.destroy();
      }
    },
  };
})(jQuery);

jQuery.nn_mobile_breakpoint = 1280;
jQuery.nn_page_get_width = function () {
  return window.innerWidth > 0 ? window.innerWidth : screen.width;
};

/* Main Menu Keyboard Tab expanding functionality */
(function ($) {
  var $menuItemsLinks = $("menu--main a, .menu--main span");
  $(".menu--main .menu a, .menu--main .menu span")
    .focusin(function (e) {
      var $menuItemLink = $(this);
      var $menuItemWrap = $menuItemLink.closest(".menu-item");
      var $menuItemParent = $menuItemWrap.parent().closest(".menu-item");
      /* Remove all of the focused classes from the sub menus */
      $menuItemWrap
        .closest(".menu")
        .find(".is-focused")
        .removeClass("is-focused");
      /* If the parent of the menu item doesn't have a focused class - add it */
      if ($menuItemParent.length && !$menuItemParent.hasClass("is-focused")) {
        $menuItemParent.addClass("is-focused");
      }
      $menuItemWrap.addClass("is-focused");
    })
    .focusout(function (e) {
      var $menuItemLink = $(this);
      var $menuItemWrap = $menuItemLink.closest(".menu-item");
      var $menuItemParent = $menuItemWrap.parent().closest(".menu-item");
      // if it's the last element in the menu remove the parent's focus class
      if (
        $.inArray($menuItemLink.attr("class")) ===
        $menuItemsLinks.length - 1
      ) {
        $menuItemParent.removeClass("is-focused");
      }
      $menuItemWrap.removeClass("is-focused");
    });
})(jQuery);

/* Desktop Menu click */
(function ($) {
  Drupal.behaviors.desktopMenuClick = {
    attach: function (context, settings) {

      once('attachDesktopMenuClickHandlers', 'html', context).forEach(function(element) {

        let main_menu_expanded = ".menu--main .menu-level-0 > .menu-item.menu-item--expanded";
        $(main_menu_expanded + " > a, " + main_menu_expanded + " > span").click(function (e) {
          if ($.nn_page_get_width() >= $.nn_mobile_breakpoint) {

            e.preventDefault();
            e.stopPropagation();


            // Toggle the clicked item
            const dropdown = $(this).parent().children(".menu-dropdown-0");
            if (!dropdown.hasClass("menu-open")) {
              // Close all "menu open" classes from other menu items
              $(".menu-dropdown-0").removeClass("menu-open");
              $(".menu-item").children("a, span").removeClass("selected");

              $(this).addClass("selected");
              dropdown.addClass("menu-open");
            } else {
              $(this).removeClass("selected");
              dropdown.removeClass("menu-open");
            }

            //Hide menu when clicked outside
            $(this)
              .parent()
              .children(".menu-dropdown-0")
              .parent()
              .mouseleave(function () {
                let thisUI = $(this);
                $("html").click(function () {
                  thisUI.children(".menu-dropdown").removeClass("menu-open");
                  thisUI.children("a, span").removeClass("selected");
                  $("html").unbind("click");
                });
              });
          }
        });

      })


    }
  }

})(jQuery);

/* Mobile Menu toggle */
/* (function ($) {
  $(".header-mobile-nav .mobile-nav").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).toggleClass("open");
    $(".region-header-wrapper").slideToggle();
    $("#block-exposedformsearchpage-1").slideUp(100);
  });
})(jQuery); */

/* Knowledge Menu toggle */
(function ($) {
  $("#resource-page-menu-toggle").click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    $(this).toggleClass("resource-page-menu-toggle--open");

    $("#resource-page-menu").slideToggle(250, function () {
      if ($("#resource-page-menu-toggle").attr("aria-expanded") === "true") {
        $("#resource-page-menu-toggle").attr("aria-expanded", "false");
      } else {
        $("#resource-page-menu-toggle").attr("aria-expanded", "true");
      }
    });
  });
})(jQuery);

/* Mobile Menu - Show second level menu on click plus icon */
/* (function ($) {
  $(".menu--main .menu-item--expanded .menu-item--arrow").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).toggleClass("expanded");
    $(this).parent().children(".menu-dropdown").slideToggle();
  });
})(jQuery); */

/* Main Navigation - Pushing down the main content if the sub menu is expanded and visible */
// (function ($) {
//   Drupal.behaviors.pushNavDown = {
//     attach: function (context, settings) {
//       if ($(".menu--main .menu-item--expanded.menu-item--active-trail > .menu .menu-item.menu-item").css('opacity') == "1") {
//         if ($.nn_page_get_width() > $.nn_mobile_breakpoint) { // medium size screen
//           $('main').css('padding-top', '15em');
//         }
//         if ($.nn_page_get_width() > $.nn_medium_breakpoint) { // full size screen
//           $('main').css('padding-top', '10em');
//         }
//       }
//     }
//   };
// }(jQuery));

/* Events Navigation - Show/hide menu items. */
(function ($) {
  if ($.nn_page_get_width() < $.nn_mobile_breakpoint) {
    $(".event-menu-element.current-element").click(function (e) {
      /* Put the current element on top of other menu elements. */
      $(this).each(function () {
        $(this).parent().prepend(this);
      });
      /* Show other menu elements. */
      $(".event-menu-element").toggleClass("menu-item--show");
      /* Add class to the menu wrapper for showing the box shadow. */
      $(".event-menu-wrapper").toggleClass("menu--active");
      e.preventDefault();
    });
  }
})(jQuery);

/* Events - Agenda Paragraph - Switch between dates. */
(function ($) {
  jQuery.itemsCount = $(
    ".field--name-field-agenda > .field__items > .field__item"
  ).length;
  jQuery.itemClass = ".field--name-field-agenda > .field__items > .field__item";

  // Main settings.
  jQuery.start_limit = 0;
  jQuery.end_limit = 2;
  jQuery.show_items = 2;

  // For mobile.
  if ($.nn_page_get_width() < $.nn_mobile_breakpoint) {
    jQuery.end_limit = 1;
    jQuery.show_items = 1;
  }

  if ($.itemsCount <= jQuery.show_items) {
    $(".agenda-navigation").addClass("agenda-navigation--hidden");
  }

  function makeActive() {
    // Add active class to first item(s).
    for (var i = $.start_limit; i < $.end_limit; i++) {
      $("" + $.itemClass + ":eq(" + i + ")").addClass("active");

      // Disable Previous button.
      if ($.start_limit === 0) {
        $("button.previous").prop("disabled", true);
      } else {
        $("button.previous").prop("disabled", false);
      }
      // Disable Next button.
      if ($.itemsCount <= $.end_limit) {
        $("button.next").prop("disabled", true);
      } else {
        $("button.next").prop("disabled", false);
      }
    }
  }

  // Initialize the function.
  makeActive();

  $("button").click(function (e) {
    // Next and previous buttons actions
    if ($(this).hasClass("next")) {
      jQuery.buttonSign = "+";
    }
    if ($(this).hasClass("previous")) {
      jQuery.buttonSign = "-";
    }

    if ($($.itemClass).hasClass("active")) {
      $($.itemClass).removeClass("active");
      if ($.buttonSign == "+") {
        $.start_limit = $.start_limit + $.show_items;
        $.end_limit = $.end_limit + $.show_items;
      } else if ($.buttonSign == "-") {
        $.start_limit = $.start_limit - $.show_items;
        $.end_limit = $.end_limit - $.show_items;
      }
      makeActive();
    }
    e.preventDefault();
  });
})(jQuery);

/* Get in touch toggle. */
(function ($) {
  $("#block-getintouchblock .field--name-field-title").click(function (e) {
    $("#block-getintouchblock").addClass("block-block-content--active");
    e.preventDefault();
  });

  $("#block-getintouchblock .field--name-field-close-button").click(function (
    e
  ) {
    $("#block-getintouchblock").removeClass("block-block-content--active");
    e.preventDefault();
  });

  /* Close the form if you click outside of it. */
  $(document).on("click", function (e) {
    if (!$(e.target).closest("#block-getintouchblock").length) {
      if ($("#block-getintouchblock").hasClass("block-block-content--active")) {
        $("#block-getintouchblock").removeClass("block-block-content--active");
      }
    }
  });
})(jQuery);

/* Centering height of image boxes */
/* (function ($) {

  $(document).ready(function () {
    var debounceSameImageBoxesHeights = Drupal.debounce(sameImageBoxesHeights, 100);

    debounceSameImageBoxesHeights();

    // Fire debounce function on resize
    $(window).resize(debounceSameImageBoxesHeights);

    function sameImageBoxesHeights() {
      var $imageBoxesWrappers = $('.field--name-field-image-boxes');

      // For each image box wrapper on the page
      $imageBoxesWrappers.each(function () {
        var $imageBoxWrapper = $(this);
        var $imageBoxes = $imageBoxWrapper.find('.field-collection-item--name-field-image-boxes');
        var $imageBoxesContent = $imageBoxes.find('.content');
        var maxHeight = 520;

        // Get the max height of the image boxes
        $imageBoxesContent.each(function () {
          var $imageBox = $(this);

          $imageBox.css('min-height', 0);

          if ($imageBox.outerHeight() > maxHeight) {
            maxHeight = $imageBox.outerHeight();
          }
        });

        // Set image boxes to new min height
        $imageBoxes.each(function () {
          $(this).css('min-height', maxHeight);
        });
      });
    }
  });

})(jQuery); */

/* Wrap the full-width image in the regular page, wrap the attendees and client list table for mobile. */
(function ($) {
  $('img[data-full-width="1"]').wrapAll('<div class="img-full-width"></div>');

  if ($.nn_page_get_width() < $.nn_mobile_breakpoint) {
    $(".page-node-type-event table, .page-node-type-client-list table").wrapAll(
      '<div class="table-wrapper"></div>'
    );
  }
})(jQuery);

/* Close the speaker popup window when you click outside the dialog. */
(function ($) {
  $(document).on("click", ".ui-widget-overlay", function () {
    //Close the dialog
    $("#drupal-modal").dialog("close");
  });
})(jQuery);

(function ($) {
  $(document).on("click", ".speaker-item", function () {
    $(this).toggleClass('open')
  });
})(jQuery);


/* Wrap Employee List Page views fields. */
(function ($) {
  $(".view-staff-list .views-row, .view-board-mem-list .views-row").each(
    function () {
      $(
        ".views-field-title, .views-field-field-intro, .views-field-body, .views-field-view-node",
        this
      ).wrapAll('<div class="employee-details">');
    }
  );
})(jQuery);

/* Scroll Mailshrimp signup form for Netnod blog into view */
(function ($) {
  Drupal.behaviors.ScrollMailchimpIntoView = {
    attach: function (context, settings) {
      $(".field--type-link.mailchimp--scroll-into-view").click(function () {
        event.preventDefault();
        var mailchimp = document.getElementById(
          "block-mailchimpsubscriptionformsubscribetoourblog"
        );
        mailchimp.scrollIntoView({ behavior: "smooth" });
      });
    },
  };
})(jQuery);

/* Make table sortable (tablesorter module). */
(function ($) {
  Drupal.behaviors.AddTablesorterClass = {
    attach: function (context, settings) {
      $(
        "div.field--type-text-with-summary > table, div.field--type-text-long > table, div.attendees-table table"
      )
        .addClass("tablesorter")
        .wrap("<div class='table--scrollbar-wrapper'></div>");
    },
  };
})(jQuery);

(function ($) {
  Drupal.behaviors.AddMahilchimpPlaceholder = {
    attach: function (context, settings) {
      $("#edit-mergevars-email").attr("placeholder", "  Your e-mail");
    },
  };
})(jQuery);

/* Trigger NN Numbers animation when in viewport */
(function ($) {
  Drupal.behaviors.animateImages = {
    attach: function (context, settings) {
      var numbersAnimated = false;

      $.fn.isInViewport = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
      };

      $(window).on("resize scroll", function () {
        $(".flex-container").each(function () {
          if ($(this).isInViewport()) {
            $(".nn-numbers-animation").addClass("animate");
            animateNumbers(true);
          } else {
            $(".nn-numbers-animation").removeClass("animate");
            $(".nn_numbers").each(function () {
              numbersAnimated = false;
              $(this).text("0");
            });
          }
        });
      });

      function animateNumbers() {
        if (numbersAnimated == true) {
          return;
        }
        $(".nn_numbers").each(function () {
          var $this = $(this),
            countTo = $this.attr("data-count");
          var isPercentage = "";
          $({ countNum: $this.text() }).animate(
            {
              context: this,
              countNum: countTo,
            },
            {
              duration: 1500,
              easing: "linear",
              step: function () {
                $this.text(Math.floor(this.countNum));
              },
              complete: function () {
                $this.text(this.countNum + isPercentage);
                //alert('finished');
              },
            }
          );
          numbersAnimated = true;
        });
      }
    },
  };
})(jQuery);

(function ($) {
  $("iframe").each(function () {
    $(this).wrap('<div class="iframe-wrapper" />'); //Wrapper needed for responsive iframes.

    var frameborder = $(this).attr("frameborder");

    if (typeof frameborder === "undefined" || frameborder === false) {
      //Add frameborder = 0 if not already set.

      $(this).attr("frameborder", "0");
    }
  });
})(jQuery);

/* Expandable content */
(function ($) {
  $(".field--name-field-expandable-content-label").click(function () {
    const expandableContainer = $(this).parent().next();

    $(this).toggleClass("active").next();
    expandableContainer.toggleClass("active");
  });

  $(".paragraph--type--nn-wide-image .field--name-field-block-link a").click(function(e) {

    const href = $(this).attr('href');
    if (href.startsWith('#')) {
      $(href+" .field--name-field-expandable-content-label:not(.active)").trigger('click');
    }

  });

})(jQuery);

/* WYSIWYG tables */

(function ($) {
  var tables = $(
    ".text-formatted table, .blog-field.ck-editor-5 table, .attendees-table table"
  );

  tables.each(function () {
    let labels = [];
    const table = $(this);

    table.find("th").each(function () {
      labels.push($(this).text());
    });

/*    var thead = table.find("thead tr").clone();
    table.find("tbody").prepend(thead);*/

    table.find("tr").each(function () {
      $(this)
        .find("td")
        .each(function (index) {
          $(this)
            .wrapInner('<div class="td-value"></div>')
            .prepend('<div class="td-label">' + labels[index] + "</div>");
        });
    });
  });
})(jQuery);

/* Search */
(function ($) {
  Drupal.behaviors.searchToggle = {
    attach: function (context, settings) {

      once('attachSearchClickHandlers', 'html', context).forEach(function(element) {

        $('a[href="/search"]').click(function (e) {
          e.preventDefault();
          $("#search-overlay").toggleClass("active");
          $("#edit-search-api-fulltext").focus();
        });

        $("#search-close").click(function () {
          $("#search-overlay").removeClass("active");
        });

        $(document).keydown(function (event) {
          if (event.key === "Escape" || event.keyCode === 27) {
            $("#search-overlay").removeClass("active");
          }
        });

      });


    },
  };
})(jQuery);

/* Mobile navigation */
(function ($) {
  Drupal.behaviors.expandMobileNav = {
    attach: function (context, settings) {

      once('attachMenuClickHandlers', 'html', context).forEach(function(element) {
        if ($.nn_page_get_width() <= $.nn_mobile_breakpoint) {
          $(".menu--main .menu-item--expanded.menu-item--active-trail > .menu-dropdown").addClass('expanded');
          $(".menu--main .menu-item--expanded.menu-item--active-trail > .menu-expander").addClass('expanded');
          $(".menu--main .menu-item--expanded.menu-item--active-trail").addClass('expanded');
        }


        $('div.header-mobile-nav .mobile-nav').click(function (e) {
          if ($.nn_page_get_width() <= $.nn_mobile_breakpoint) {
            e.preventDefault();
            $(".region-header, .mobile-nav").toggleClass("expanded");
          }
        });

        $('.menu-item--expanded .menu-expander, .menu-item--expanded > span').click(function (e) {
          if ($.nn_page_get_width() <= $.nn_mobile_breakpoint) {
            e.preventDefault();
            $(this).parent().toggleClass('expanded');
            $(this).parent().find(' > .menu-expander').toggleClass('expanded');
            $(this).parent().find(' > .menu-dropdown').toggleClass('expanded');
          }
        });

        $(window).on("resize", function() {
          $(".region-header, .mobile-nav").removeClass("expanded");
          $(".menu--main .menu-item--expanded.menu-item--active-trail .menu-dropdown").removeClass('expanded');
          $(".menu--main .menu-item--expanded.menu-item--active-trail .menu-expander").removeClass('expanded');
          $(".menu--main .menu-item--expanded.menu-item--active-trail").removeClass('expanded');
        });


      })


    },
  };
})(jQuery);
